export function prepareSubscription(subscription) {
  if (subscription === null) {
    return null;
  }
  var _subscription$toJSON = subscription.toJSON(),
    endpoint = _subscription$toJSON.endpoint,
    keys = _subscription$toJSON.keys;
  if (endpoint && keys && keys.auth && keys.p256dh) {
    return {
      endpoint: endpoint,
      keys: {
        auth: keys.auth,
        p256dh: keys.p256dh
      }
    };
  }
  return null;
}